require('initializers/gettext').default(__TRANSLATIONS__.gettext.nb); // eslint-disable-line no-undef
require('initializers/i18n').default('nb', __TRANSLATIONS__.i18n.nb); // eslint-disable-line no-undef

require('locales/dependencies');

require('select2/dist/js/i18n/nb');
require('jquery-ui/ui/i18n/datepicker-nb');
require('dayjs/locale/nb');
